import moment from 'moment';

export const getScheduleRange = (
  start?: string | null,
  end?: string | null
) => {
  const startMoment = moment(start, 'HH:mm:ss');
  const endMoment = moment(end, 'HH:mm:ss');
  const isValid = startMoment.isValid() && endMoment.isValid();

  if (isValid) {
    return `${startMoment.format('HH:mm')} - ${endMoment.format('HH:mm')}`;
  }

  return '-';
};
